module.exports = __webpack_public_path__ + "68594f550f353ed8bfd359f25626b2a8.pdf";